<p-dialog appDialogoPadrao="pi pi-map-marker" descricao="Restringe o relatório a um município." [(visible)]="visible" [style]="{ width: '480px' }" header="Buscar Município" (onShow)="onShow()">
    <div class="mb-3">
        <label class="label" for="filtroMunicipio">Nome do Município</label>
        <input pInputText id="filtroMunicipio" class="w-full" [ngModel]="filtro()" (ngModelChange)="filtro.set($event)" placeholder="Digite o nome do município" aria-label="Nome do município" />
    </div>

    <p-table
        [value]="municipiosFiltrados()"
        [scrollable]="true"
        scrollHeight="280px"
        [loading]="carregando()"
        selectionMode="single"
        [selection]="selecionado()"
        (selectionChange)="selecionar($event)"
        dataKey="id"
        [ariaLabel]="'Tabela de municípios'"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>Município</th>
                <th style="width: 60px">UF</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
            <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex" (dblclick)="selecionar(row); confirmar()">
                <td>{{ row.dsMunicipio }}</td>
                <td>{{ row.uf }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="2" style="text-align: center">Nenhum município encontrado.</td>
            </tr>
        </ng-template>
    </p-table>

    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" label="Confirmar" (onClick)="confirmar()" [disabled]="!selecionado()" />
        <p-button icon="pi pi-times" label="Cancelar" severity="secondary" (onClick)="cancelar()" />
    </ng-template>
</p-dialog>
